<template>
  <div class="front-view">

    <div class="graph-view_describe">
      <div class="graph-view_availablerange"><span class="graph-view_block"></span><span class="graph-view_text">{{$t(strColor1)}}</span></div>
    </div>
    <div class='graph-view_checkbox'>
        <div class='Projector_checkbox'>
          <van-checkbox v-model='projector_checked' shape="square"><span>{{$t('T_CHANGE_PJ_POS')}}</span></van-checkbox>
        </div>
        <div class='Screen_checkbox'>
          <van-checkbox v-model='screen_checked' :disabled="throwDistanceChecked || (hLensShiftMax === hLensShiftMin && vLensShiftMax === vLensShiftMin) || vAngleFlag || hAngleFlag" shape="square"><span>{{$t('T_CHANGE_SCREEN_POS')}}</span></van-checkbox>
        </div>
    </div>
    <Cv
      id="frontView"
      :w="widthInit"
      :h="heightInit"
      :pjRect="pjImgRect"
      :roomRect="roomRect"
      :arrDashLines="arrDashLines"
      :arrDashRemainLines="arrDashRemainLines"
      :arrRectLines="arrRectLines"
      :avlRect="avlRect"
      :arrHelpLines="arrHelpLines"
      :arrHelpText="arrHelpText"
      :arrCatchArea="arrCatchArea"
      :arrBlackArea="arrBlackArea"
      :arrRectHorSecLines="arrRectHorSecLines"
      :arrowRects="arrowRects"
      ref="frontView"
      @removeCenter="removeCenter"
      @setArrHelpLine="setArrHelpLine"
    >
    </Cv>
    <div class="graph-slider-block">
      <div class="slider-title-v">{{ $t(slider1Title) }} ({{ slider1Append }})</div>
      <div class="slider-content">
        <div class="slider-item">{{ slider1Msg1 }}</div>
        <el-slider
        v-model="vLensShiftData"
        :max="vLensShiftMax"
        :min="vLensShiftMin"
        vertical
        :height="slider1Height"
        :format-tooltip="formatTooltip"
        :show-tooltip= false
        :disabled="vLensShiftMax === vLensShiftMin"
        >
      </el-slider>
      <div class="slider-item"></div>
        <div class="graph-view_slider-input">
          <!-- <inputValidateBox prop='vLensShiftDataInput' :rules="rules.number"> -->
            <van-field v-model.number="vLensShiftDataInput" class="side_input"
              @input="testDigitalNegative($event, 'vLensShiftDataInput', 'setVlensShift')"
              :disabled="vLensShiftMax === vLensShiftMin"
              @blur="checkRange('vLensShiftDataInput', vLensShiftMax, vLensShiftMin)">

              <!-- <template slot="right-icon"><span >{{ slider1Append }}</span></template> -->
            </van-field>
          <!-- </inputValidateBox> -->
        </div>
      </div>
      <div class="slider-item">{{ $t(slider1Msg2) }}</div>
    </div>
    <div class="slider-content-h">
      <div class="slider-title-h">{{ $t(slider2Title) }} ({{ slider2Append }})</div>
      <div class="inline">
        <div class="slider-h-line">
          <el-slider
            v-model="hLensShiftData"
            :max="hLensShiftMax"
            :min="hLensShiftMin"
            :format-tooltip="formatTooltip"
            :show-tooltip= false
            class="slider-h"
            :disabled="hLensShiftMax === hLensShiftMin"
            >
          </el-slider>
        </div>
        <div class="slider-input-panel">
          <!-- <inputValidateBox prop='hLensShiftDataInput' :rules="rules.number"> -->
            <van-field v-model.number="hLensShiftDataInput" class="front_input_H side_input"
              @input="testDigitalNegative($event,'hLensShiftDataInput', 'setHlensShift')"
              :disabled="hLensShiftMax === hLensShiftMin"
              @blur="checkRangeH('hLensShiftDataInput', hLensShiftMax, hLensShiftMin)">
              <!-- <template slot="right-icon"><span >{{ slider2Append }}</span></template> -->
            </van-field>
          <!-- </inputValidateBox> -->
        </div>
      </div>
      <div class="horizontal">{{ $t(slider2Msg2) }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
// import inputValidateBox from '@/components/inputValidateBox'
export default {
  name: 'frontView',
  data () {
    return {
      title: 'T_FRONT_VIEW',
      greenMsg: 'T_LENS_SHIFT_RANGE',
      slider1Title: 'T_LENS_SHIFT',
      slider1Msg1: '',
      slider1Msg2: 'T_VERTICAL',
      strColor1: 'T_AVAILABLE_RANGE',
      slider1Max: this.vLensShiftMax,
      slider1Min: this.vLensShiftMin,
      slider1Append: '%',
      slider2Title: 'T_LENS_SHIFT',
      slider2Msg1: '',
      slider2Msg2: 'T_HORIZONTAL',
      slider2Max: this.hLensShiftMax,
      slider2Min: this.hLensShiftMin,
      slider2Append: '%',
      child: null,

      pjImgRect: {},
      roomRect: {},
      avlRect: [],
      arrDashLines: [],
      arrDashRemainLines: [],
      arrRectLines: [],
      arrCatchArea: [],
      arrBlackArea: [],
      arrHelpLines: [],
      arrHelpText: [],
      arrRectHorSecLines: [],
      widthInit: 0,
      heightInit: 0,

      helpDisMin: 20,
      helpDisMax: 40,
      helpTextDis: 37,
      helpNeDis: 40,
      // 左右边辅助线文字的距离
      helpBesideDis: 35,
      slider1Height: '0px',
      slider2Height: '0px',
      rules: {
        'number': [
          { required: true, message: '必填' },
          { type: 'number', message: '请输入数字' }
        ]
      },
      vLensShiftDataInput: 0,
      hLensShiftDataInput: 0,
      arrowRects: [],
      position: {
        x: 0,
        y: 0
      },
      isLShaped01: this.$commonViewJs.isLShaped01(),
      isLShaped: this.$commonViewJs.isLShaped()
    }
  },
  components: {
    // inputValidateBox
  },
  computed: {
    ...mapState([
      'pjY',
      'pjZ',
      'graph',
      'vAngle',
      'houseInfo',
      'vAngleFlag',
      'hAngleFlag',
      'projectorChecked',
      'screenMoveChecked',
      'drawData',
      'blackDrawData',
      'lenghProInit',
      'widthProInit',
      'lenghLSProInit',
      'widthLSProInit',
      'rangeDrawData',
      'screenSizeChecked',
      'throwDistanceChecked',
      'vLensShiftNow',
      'hLensShiftNow',
      'flToB',
      'flToL',
      'initScreenSize',
      'dashData',
      'dashFlag',
      'isTouch',
      'throw_distance_checked',
      'language'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    vLensShiftMax: {
      get () {
        return this.graph.vLensShift.max * 10000 / 100
      }
    },
    vLensShiftMin: {
      get () {
        return this.graph.vLensShift.min * 10000 / 100
      }
    },
    vLensShiftData: {
      get () {
        return this.vLensShiftNow
      },
      set (value) {
        this.setVlensShift(value)
      }
    },

    hLensShiftMax: {
      get () {
        return this.graph.hLensShift.max * 10000 / 100
      }
    },
    hLensShiftMin: {
      get () {
        return this.graph.hLensShift.min * 10000 / 100
      }
    },
    hLensShiftData: {
      get () {
        return this.hLensShiftNow
      },

      set (value) {
        this.setHlensShift(value)
      }
    },
    projector_checked: {
      get () {
        return this.projectorChecked
      },
      set (value) {
        if (value && this.screenMoveChecked) {
          this.SET_SCREENMOVECHECKED(false)
        }
        this.SET_PROJECTORCHECKED(value)
      }
    },
    screen_checked: {
      get () {
        return this.screenMoveChecked
      },
      set (value) {
        if (value && this.projectorChecked) {
          this.SET_PROJECTORCHECKED(false)
        }
        this.SET_SCREENMOVECHECKED(value)
      }
    }
  },
  created () {
    this.widthInit = this.houseInfo.roomW
    this.isLShaped01 = this.$commonViewJs.isLShaped01()
    this.heightInit = this.isLShaped01 ? this.houseInfo.roomD : this.houseInfo.roomH
  },
  mounted () {
    this.child = this.$refs.frontView
    this.slider1Height = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px' // TODO
    this.slider2Height = this.slider1Height
    this.vLensShiftDataInput = this.vLensShiftMax === this.vLensShiftMin ? 0 : parseInt(this.vLensShiftData)
    this.hLensShiftDataInput = this.hLensShiftMax === this.hLensShiftMin ? 0 : parseInt(this.hLensShiftData)

    this.initCanvasData()
    this.$watch('drawData', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, { deep: true })
    this.$watch('graph', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, { deep: true })

    this.$watch('houseInfo', function () {
      this.initCanvasData()
      this.widthInit = this.houseInfo.roomW
      this.heightInit = this.isLShaped01 ? this.houseInfo.roomD : this.houseInfo.roomH
      this.$nextTick(function () {
        this.child.onHouseInfoChanged()
      })
    }, { deep: true })

    // this.$watch('vLensShiftData', (newValue, oldValue) => {
    //   this.vLensShiftDataInput = this.vLensShiftMax === this.vLensShiftMin ? 0 : Number(newValue.toFixed(0))
    // })
    // this.$watch('hLensShiftData', (newValue, oldValue) => {
    //   this.hLensShiftDataInput = this.hLensShiftMax === this.hLensShiftMin ? 0 : Number(newValue.toFixed(0))
    // })
  },
  methods: {
    ...mapMutations([
      'PJX',
      'PJZ',
      'PJY',
      'SET_VLENSSHIFT',
      'SET_HLENSSHIFT',
      'SET_OLDTX',
      'SET_OLDTY',
      'SET_FLOOR2BOTTOM',
      'SET_PROJECTORCHECKED',
      'SET_SCREENMOVECHECKED',
      'SET_PJXTIP',
      'SET_PJZTIP',
      'SET_ISINFRONTVIEW'
    ]),
    formatTooltip (val) {
      return parseInt(val)
    },
    enter () {
      this.SET_ISINFRONTVIEW(true)
    },
    leave () {
      this.SET_ISINFRONTVIEW(false)
    },

    initCanvasData () {
      if (!this.drawData) {
        return
      }
      this.isLShaped = this.$commonViewJs.isLShaped()
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      this.widthInit = this.houseInfo.roomW
      this.heightInit = this.isLShaped01 ? this.houseInfo.roomD : this.houseInfo.roomH
      this.arrRectPoints = this.drawData[0]
      // 房间矩形边框
      this.roomRect = null
      // 连线
      this.arrRectLines = []
      // 镜头水平倾斜时出现的第二条屏幕延伸线数组
      this.arrRectHorSecLines = []
      // 虚线
      this.arrDashLines = []
      this.arrDashRemainLines = []
      // 投影仪可拖动区域
      this.avlRect = []
      // 辅助线
      this.arrHelpLines = []
      // 辅助线上尺寸大小
      this.arrHelpText = []
      // 投影区域
      this.arrCatchArea = []
      // 黑边区域
      this.arrBlackArea = []
      this.arrowRects = []

      this.setPjRect()
      this.setArrDashLines()
      this.setArrDashRemainLines()
      this.setRoomRect()
      this.setAvlRect()
      this.setArrCatchArea()
      this.setArrBlackArea()
    },

    setArrBlackArea () {
      // console.log(this.blackDrawData)
      if (!this.blackDrawData) {
        return
      }
      let param = this.isLShaped01 ? 'y' : 'z'
      for (let i = 1; i < this.blackDrawData.length; i++) {
        for (let j = 0; j < this.blackDrawData[i].length; j++) {
          this.arrBlackArea.push(this.$draw.toPoint(this.blackDrawData[i][j].x, this.blackDrawData[i][j][param]))
        }
      }
    },
    setPjRect () {
      var x = this.$commonViewJs.getAx()
      var y = this.isLShaped01 ? this.$commonViewJs.getAy() : this.$commonViewJs.getAz()
      var width = this.isLShaped ? this.lenghLSProInit : this.lenghProInit
      var height = this.isLShaped ? this.widthLSProInit : this.widthProInit

      this.pjImgRect = this.$draw.toRect(x, y, width, height)
    },
    setRoomRect () {
      this.roomRect = this.$draw.toRect(
        0,
        0,
        this.houseInfo.roomW,
        this.heightInit
      )
    },
    setAvlRect () {
      if (this.vLensShiftMax === this.vLensShiftMin) {
        return
      }
      let param = this.isLShaped01 ? 'y' : 'z'
      for (let i = 0; i < this.rangeDrawData.length; i++) {
        var avlLines = this.$draw.toPoint(
          this.rangeDrawData[i].x,
          this.rangeDrawData[i][param]
        )
        this.avlRect.push(avlLines)
      }
    },

    setArrCatchArea () {
      if (!this.drawData) {
        return
      }
      let param = this.isLShaped01 ? 'y' : 'z'
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          this.arrCatchArea.push(this.$draw.toPoint(this.drawData[i][j].x, this.drawData[i][j][param]))
        }
      }
    },
    setArrDashLines () {
      var dashLine0, dashLine1
      let getDx = this.$commonViewJs.getDx()
      if (this.isLShaped01) {
        let getSy = this.$commonViewJs.getSy()
        dashLine0 = this.$draw.toLine(0, getSy, this.widthInit, getSy, '#999999', 1)
        dashLine1 = this.$draw.toLine(getDx, 0, getDx, this.heightInit, '#999999', 1)
      } else {
        dashLine0 = this.$draw.toLine(0, this.$commonViewJs.getSz(), this.$commonViewJs.getRx(), this.$commonViewJs.getRz(), '#999999', 1)
        dashLine1 = this.$draw.toLine(getDx, 0, this.$commonViewJs.getFx(), this.$commonViewJs.getFz(), '#999999', 1)
      }
      this.arrDashLines.push(dashLine0)
      this.arrDashLines.push(dashLine1)
    },
    setArrDashRemainLines () {
      // 屏幕锁定在点击倾斜角度时，获取的屏幕虚线
      var dashLine1
      if (this.dashFlag) {
        let param = this.isLShaped01 ? 'y' : 'z'
        for (let i = 1; i < this.dashData.length; i++) {
          for (let j = 1; j < this.dashData[i].length; j++) {
            dashLine1 = this.$draw.toLine(this.dashData[i][j - 1].x, this.dashData[i][j - 1][param], this.dashData[i][j].x, this.dashData[i][j][param], '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          }
          if (i === this.dashData.length - 1) {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].x, this.dashData[i][this.dashData[i].length - 1][param], this.dashData[1][0].x, this.dashData[1][0][param], '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          } else {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].x, this.dashData[i][this.dashData[i].length - 1][param], this.dashData[i + 1][0].x, this.dashData[i + 1][0][param], '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          }
        }
      }
    },
    setMiddleHelpLine () {
      var downNeDis = 0
      if (this.$commonViewJs.formatData(this.arrRectPoints[1].x - this.arrRectPoints[0].x) !== this.$commonViewJs.formatData(this.arrRectPoints[2].x - this.arrRectPoints[3].x)) {
        downNeDis = this.helpNeDis
      }
      var middleLine0 = this.$draw.toLine(
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + 50,
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpDisMax + downNeDis + 50,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(middleLine0)
      middleLine0 = this.$draw.toLine(
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + 50,
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpDisMax + downNeDis + 50,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(middleLine0)
      middleLine0 = this.$draw.toLine(
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpDisMax + downNeDis + 50,
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpDisMax + downNeDis + 50,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(middleLine0)
      var arrowRect0 = this.$draw.toArrow(
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + 50,
        this.graph.pjX / 2 - 10,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + 60,
        this.graph.pjX / 2 + 10,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + 60,
        this.$constant.helpLineColor
      )
      this.arrowRects.push(arrowRect0)
      arrowRect0 = this.$draw.toArrow(
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + 50,
        (this.houseInfo.roomW + this.graph.pjX) / 2 - 10,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + 60,
        (this.houseInfo.roomW + this.graph.pjX) / 2 + 10,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + 60,
        this.$constant.helpLineColor
      )
      this.arrowRects.push(arrowRect0)
    },
    setArrHelpLine (proportion) {
      this.helpDisMin = 10 * proportion
      this.helpDisMax = 18 * proportion
      this.helpTextDis = 20 * proportion
      this.helpNeDis = 20 * proportion
      this.helpBesideDis = 10 * proportion
      this.arrHelpLines.splice(0, this.arrHelpLines.length)
      this.arrHelpText.splice(0, this.arrHelpText.length)
      this.arrowRects.splice(0, this.arrowRects.length)

      if (this.isLShaped01) {
        this.setArrHelpLineLShaped(proportion)
        return
      }

      // ================上辅助线===============
      var helpLine0 = this.$draw.toLine(
        0,
        0 - this.helpDisMin,
        0,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)
      helpLine0 = this.$draw.toLine(
        this.arrRectPoints[0].x,
        0 - this.helpDisMin,
        this.arrRectPoints[0].x,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)
      helpLine0 = this.$draw.toLine(
        this.arrRectPoints[1].x,
        0 - this.helpDisMin,
        this.arrRectPoints[1].x,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)
      helpLine0 = this.$draw.toLine(
        this.houseInfo.roomW,
        0 - this.helpDisMin,
        this.houseInfo.roomW,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)
      helpLine0 = this.$draw.toLine(
        0,
        0 - (this.helpDisMax + this.helpDisMin) / 2,
        this.houseInfo.roomW,
        0 - (this.helpDisMax + this.helpDisMin) / 2,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)

      // ============右辅助线================
      var neDis = 0
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[3].z - this.arrRectPoints[0].z, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].z - this.arrRectPoints[1].z, this.graph.unit, false)) {
        neDis = this.helpNeDis
        var helpLine10 = this.$draw.toLine(
          this.houseInfo.roomW + this.helpDisMin,
          this.arrRectPoints[1].z,
          this.houseInfo.roomW + this.helpDisMax,
          this.arrRectPoints[1].z,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine10)
        helpLine10 = this.$draw.toLine(
          this.houseInfo.roomW + this.helpDisMin,
          this.arrRectPoints[2].z,
          this.houseInfo.roomW + this.helpDisMax,
          this.arrRectPoints[2].z,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine10)
        helpLine10 = this.$draw.toLine(
          this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2,
          this.arrRectPoints[1].z,
          this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2,
          this.arrRectPoints[2].z,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine10)
      }
      var helpLine1 = this.$draw.toLine(
        this.houseInfo.roomW + this.helpDisMin + neDis,
        0,
        this.houseInfo.roomW + this.helpDisMax + neDis,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine1)
      helpLine1 = this.$draw.toLine(
        this.houseInfo.roomW + this.helpDisMin + neDis,
        this.houseInfo.roomH,
        this.houseInfo.roomW + this.helpDisMax + neDis,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine1)
      helpLine1 = this.$draw.toLine(
        this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2 + neDis,
        0,
        this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2 + neDis,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine1)

      // ============左辅助线================
      var helpLine2 = this.$draw.toLine(
        0 - this.helpDisMin,
        0,
        0 - this.helpDisMax,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine2)
      helpLine2 = this.$draw.toLine(
        0 - this.helpDisMin,
        this.arrRectPoints[0].z,
        0 - this.helpDisMax,
        this.arrRectPoints[0].z,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine2)
      helpLine2 = this.$draw.toLine(
        0 - this.helpDisMin,
        this.arrRectPoints[3].z,
        0 - this.helpDisMax,
        this.arrRectPoints[3].z,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine2)
      helpLine2 = this.$draw.toLine(
        0 - this.helpDisMin,
        this.houseInfo.roomH,
        0 - this.helpDisMax,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine2)
      helpLine2 = this.$draw.toLine(
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        0,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine2)

      // ============下辅助线================
      var downNeDis = 0
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)) {
        downNeDis = this.helpNeDis
        var helpLine30 = this.$draw.toLine(
          this.arrRectPoints[2].x,
          this.houseInfo.roomH + this.helpDisMin,
          this.arrRectPoints[2].x,
          this.houseInfo.roomH + this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine30)
        helpLine30 = this.$draw.toLine(
          this.arrRectPoints[3].x,
          this.houseInfo.roomH + this.helpDisMin,
          this.arrRectPoints[3].x,
          this.houseInfo.roomH + this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine30)
        helpLine30 = this.$draw.toLine(
          this.arrRectPoints[2].x,
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2,
          this.arrRectPoints[3].x,
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine30)
      }
      var helpLine3 = this.$draw.toLine(
        0,
        this.houseInfo.roomH + this.helpDisMin + downNeDis,
        0,
        this.houseInfo.roomH + this.helpDisMax + downNeDis,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine3)
      helpLine3 = this.$draw.toLine(
        this.graph.pjX,
        this.houseInfo.roomH + this.helpDisMin + downNeDis,
        this.graph.pjX,
        this.houseInfo.roomH + this.helpDisMax + downNeDis,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine3)
      helpLine3 = this.$draw.toLine(
        this.houseInfo.roomW,
        this.houseInfo.roomH + this.helpDisMin + downNeDis,
        this.houseInfo.roomW,
        this.houseInfo.roomH + this.helpDisMax + downNeDis,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine3)
      helpLine3 = this.$draw.toLine(
        0,
        this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis,
        this.houseInfo.roomW,
        this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine3)
      this.setArrHelpText(proportion)
    },
    setArrHelpLineLShaped (proportion) {
      // 上边的辅助线
      let pointX1 = 0
      let pointX2 = this.arrRectPoints[0].x
      let pointX3 = this.arrRectPoints[1].x
      let pointX4 = this.widthInit
      let pointY1 = 0 - this.helpDisMin
      let pointY2 = 0 - this.helpDisMax
      let pointY3 = 0 - (this.helpDisMax + this.helpDisMin) / 2
      let topPoint = []
      // 上边的竖线
      topPoint.push({ x1: pointX1, y1: pointY1, x2: pointX1, y2: pointY2 })
      topPoint.push({ x1: pointX2, y1: pointY1, x2: pointX2, y2: pointY2 })
      topPoint.push({ x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY2 })
      topPoint.push({ x1: pointX4, y1: pointY1, x2: pointX4, y2: pointY2 })
      // 上边的横线
      topPoint.push({ x1: pointX1, y1: pointY3, x2: pointX4, y2: pointY3 })
      let topHelpLine
      topPoint.forEach(item => {
        topHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(topHelpLine)
      })

      // 右边的辅助线
      var neDis = 0
      let rightPoint = []
      pointX1 = this.widthInit + this.helpDisMin
      pointX2 = this.widthInit + this.helpDisMax
      pointX3 = this.widthInit + (this.helpDisMin + this.helpDisMax) / 2
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[0].y - this.arrRectPoints[3].y, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[1].y - this.arrRectPoints[2].y, this.graph.unit, false)) {
        neDis = this.helpNeDis
        pointY1 = this.arrRectPoints[1].y
        pointY2 = this.arrRectPoints[2].y
        rightPoint = [
          { x1: pointX1, y1: pointY1, x2: pointX2, y2: pointY1 },
          { x1: pointX1, y1: pointY2, x2: pointX2, y2: pointY2 },
          { x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY2 }
        ]
      }

      rightPoint.push({ x1: pointX1 + neDis, y1: 0, x2: pointX2 + neDis, y2: 0 })
      rightPoint.push({ x1: pointX1 + neDis, y1: this.heightInit, x2: pointX2 + neDis, y2: this.heightInit })
      rightPoint.push({ x1: pointX3 + neDis, y1: 0, x2: pointX3 + neDis, y2: this.heightInit })

      let rightHelpLine
      rightPoint.forEach(item => {
        rightHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(rightHelpLine)
      })

      // 左边的辅助线
      pointX1 = 0 - this.helpDisMin
      pointX2 = 0 - this.helpDisMax
      pointX3 = 0 - (this.helpDisMax + this.helpDisMin) / 2
      pointY1 = 0
      pointY2 = this.arrRectPoints[3].y
      pointY3 = this.arrRectPoints[0].y
      let pointY4 = this.heightInit
      // 左边的横线
      let leftPoint = []
      leftPoint.push({ x1: pointX1, y1: pointY1, x2: pointX2, y2: pointY1 })
      leftPoint.push({ x1: pointX1, y1: pointY2, x2: pointX2, y2: pointY2 })
      leftPoint.push({ x1: pointX1, y1: pointY3, x2: pointX2, y2: pointY3 })
      leftPoint.push({ x1: pointX1, y1: pointY4, x2: pointX2, y2: pointY4 })
      // 左边的竖线
      leftPoint.push({ x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY4 })
      let leftHelpLine
      leftPoint.forEach(item => {
        leftHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(leftHelpLine)
      })

      // 下边的辅助线
      var downNeDis = 0
      let bottomPoint = []
      pointY1 = this.heightInit + this.helpDisMin
      pointY2 = this.heightInit + this.helpDisMax
      pointY3 = this.heightInit + (this.helpDisMin + this.helpDisMax) / 2
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)) {
        downNeDis = this.helpNeDis
        pointX1 = this.arrRectPoints[2].x
        pointX2 = this.arrRectPoints[3].x
        bottomPoint = [
          { x1: pointX1, y1: pointY1, x2: pointX1, y2: pointY2 },
          { x1: pointX2, y1: pointY1, x2: pointX2, y2: pointY2 },
          { x1: pointX1, y1: pointY3, x2: pointX2, y2: pointY3 }
        ]
      }
      // 下边的竖线
      pointX1 = 0
      pointX2 = this.graph.pjX
      pointX3 = this.widthInit
      pointY1 = this.heightInit + this.helpDisMin + downNeDis
      pointY2 = this.heightInit + this.helpDisMax + downNeDis
      pointY3 = this.heightInit + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis
      bottomPoint.push({ x1: pointX1, y1: pointY1, x2: pointX1, y2: pointY2 })
      bottomPoint.push({ x1: pointX2, y1: pointY1, x2: pointX2, y2: pointY2 })
      bottomPoint.push({ x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY2 })
      // 下边的横线
      bottomPoint.push({ x1: pointX1, y1: pointY3, x2: pointX3, y2: pointY3 })
      let bottomHelpLine
      bottomPoint.forEach(item => {
        bottomHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(bottomHelpLine)
      })

      this.setArrHelpTextLShaped(proportion)
    },
    setArrHelpText (proportion) {
      let bs = 10 * proportion
      let lis = 7 * proportion
      // ==================上辅助文字===============
      var textName0 = this.$commonJs.changeUnitDraw(this.arrRectPoints[0].x, this.graph.unit, false)
      var helpText0 = this.$draw.toText(
        this.arrRectPoints[0].x / 2,
        0 - this.helpTextDis,
        textName0,
        'top'
      )
      this.arrHelpText.push(helpText0)

      textName0 = this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false)
      helpText0 = this.$draw.toText(
        (this.arrRectPoints[1].x + this.arrRectPoints[0].x) / 2,
        0 - this.helpTextDis,
        textName0,
        'top'
      )
      this.arrHelpText.push(helpText0)

      textName0 = this.$commonJs.changeUnitDraw(this.houseInfo.roomW - this.arrRectPoints[1].x, this.graph.unit, false)
      helpText0 = this.$draw.toText(
        (this.houseInfo.roomW + this.arrRectPoints[1].x) / 2,
        0 - this.helpTextDis,
        textName0,
        'top'
      )
      this.arrHelpText.push(helpText0)
      textName0 = '(' + this.unitLabel + ')'
      helpText0 = this.$draw.toText(
        this.houseInfo.roomW + this.helpTextDis + this.helpBesideDis,
        0 - this.helpTextDis,
        textName0,
        'top'
      )
      this.arrHelpText.push(helpText0)

      // ==================右辅助文字===============
      // 右边标注的尺寸被覆盖，所以需要调整
      let rightMov = this.graph.unit === 'T_FEET_FRACTION' ? 60 : 0
      var neDis = 0
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[3].z - this.arrRectPoints[0].z, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].z - this.arrRectPoints[1].z, this.graph.unit, false)) {
        neDis = this.helpNeDis
        var textName10 = this.$commonJs.changeUnitDraw(this.arrRectPoints[2].z - this.arrRectPoints[1].z, this.graph.unit, false)
        var helpText10 = this.$draw.toText(
          this.houseInfo.roomW + this.helpTextDis + this.helpBesideDis - rightMov,
          (this.arrRectPoints[2].z + this.arrRectPoints[1].z) / 2 + lis,
          textName10,
          'right'
        )
        this.arrHelpText.push(helpText10)
      }
      var textName1 = this.$commonJs.changeUnitDraw(this.houseInfo.roomH, this.graph.unit, false)
      var helpText1 = this.$draw.toText(
        this.houseInfo.roomW + this.helpTextDis + neDis - rightMov,
        this.houseInfo.roomH / 2 + lis,
        textName1,
        'right'
      )
      this.arrHelpText.push(helpText1)

      // ==================左辅助文字===============
      // 左边标注的尺寸被覆盖，所以需要调整
      let leftMov = this.graph.unit === 'T_FEET_FRACTION' ? 60 : 0
      var textName2 = this.$commonJs.changeUnitDraw(this.arrRectPoints[0].z, this.graph.unit, false)
      var helpText2 = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis + leftMov,
        this.arrRectPoints[0].z / 2 + lis,
        textName2,
        'left'
      )
      this.arrHelpText.push(helpText2)

      textName2 = this.$commonJs.changeUnitDraw(this.arrRectPoints[3].z - this.arrRectPoints[0].z, this.graph.unit, false)
      helpText2 = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis + leftMov,
        (this.arrRectPoints[3].z + this.arrRectPoints[0].z) / 2 + lis,
        textName2,
        'left'
      )
      this.arrHelpText.push(helpText2)

      textName2 = this.$commonJs.changeUnitDraw(this.houseInfo.roomH - this.arrRectPoints[3].z, this.graph.unit, false)
      helpText2 = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis + leftMov,
        (this.houseInfo.roomH + this.arrRectPoints[3].z) / 2 + lis,
        textName2,
        'left'
      )
      this.arrHelpText.push(helpText2)

      // ==================下辅助文字===============
      var downNeDis = 0
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)) {
        downNeDis = this.helpNeDis
        var textName30 = this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)
        var helpText30 = this.$draw.toText(
          (this.arrRectPoints[2].x + this.arrRectPoints[3].x) / 2,
          this.houseInfo.roomH + this.helpTextDis + bs,
          textName30,
          'bottom'
        )
        this.arrHelpText.push(helpText30)
      }
      var textName3 = this.$commonJs.changeUnitDraw(this.graph.pjX, this.graph.unit, false)
      var helpText3 = this.$draw.toText(
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpTextDis + bs + downNeDis,
        textName3,
        'bottom'
      )
      this.arrHelpText.push(helpText3)
      textName3 = this.$commonJs.changeUnitDraw(this.houseInfo.roomW - this.graph.pjX, this.graph.unit, false)
      helpText3 = this.$draw.toText(
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpTextDis + bs + downNeDis,
        textName3,
        'bottom'
      )
      this.arrHelpText.push(helpText3)
    },
    setArrHelpTextLShaped (proportion) {
      let bs = 10 * proportion
      let lis = 7 * proportion

      // 上边的辅助文字
      let topText, topHelpText, topTextInfo
      let pointY1 = 0 - this.helpTextDis
      let pointX1 = this.arrRectPoints[0].x / 2
      let pointX2 = (this.arrRectPoints[1].x + this.arrRectPoints[0].x) / 2
      let pointX3 = (this.widthInit + this.arrRectPoints[1].x) / 2
      topTextInfo = [
        { text: this.arrRectPoints[0].x, x: pointX1, y: pointY1 },
        { text: this.arrRectPoints[1].x - this.arrRectPoints[0].x, x: pointX2, y: pointY1 },
        { text: this.widthInit - this.arrRectPoints[1].x, x: pointX3, y: pointY1 }
      ]
      topTextInfo.forEach(item => {
        topText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
        topHelpText = this.$draw.toText(item.x, item.y, topText, 'top')
        this.arrHelpText.push(topHelpText)
      })
      // 单位
      this.arrHelpText.push(this.$draw.toText(this.widthInit + this.helpTextDis + this.helpBesideDis, pointY1, '(' + this.unitLabel + ')', 'top'))

      // 右辅助文字
      // 右边标注的尺寸被覆盖，所以需要调整
      let rightMov = this.graph.unit === 'T_FEET_FRACTION' ? 60 : 0
      let neDis = 0
      let rightText, rightHelpText
      let rightTextInfo = []
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[0].y - this.arrRectPoints[3].y, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[1].y - this.arrRectPoints[2].y, this.graph.unit, false)) {
        neDis = this.helpNeDis
        rightText = this.arrRectPoints[1].y - this.arrRectPoints[2].y
        pointX1 = this.widthInit + this.helpTextDis + this.helpBesideDis - rightMov
        pointY1 = (this.arrRectPoints[1].y + this.arrRectPoints[2].y) / 2 + lis
        rightTextInfo.push({ text: rightText, x: pointX1, y: pointY1 })
      }
      rightText = this.heightInit
      pointX1 = this.widthInit + this.helpTextDis + neDis - rightMov
      pointY1 = this.heightInit / 2 + lis
      rightTextInfo.push({ text: rightText, x: pointX1, y: pointY1 })
      rightTextInfo.forEach(item => {
        rightText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
        rightHelpText = this.$draw.toText(item.x, item.y, rightText, 'right')
        this.arrHelpText.push(rightHelpText)
      })
      // console.log('rightTextInfo', rightTextInfo)
      // console.log('this.arrRectPoints', JSON.stringify(this.arrRectPoints), '0-3', this.arrRectPoints[0].y - this.arrRectPoints[3].y, '1-2', this.arrRectPoints[1].y - this.arrRectPoints[2].y)

      // 左边的辅助文字
      // 左边标注的尺寸被覆盖，所以需要调整
      let leftMov = this.graph.unit === 'T_FEET_FRACTION' ? 60 : 0
      let leftText, leftHelpText
      pointX1 = 0 - this.helpTextDis - this.helpBesideDis + leftMov
      pointY1 = this.arrRectPoints[3].y / 2 + lis
      let pointY2 = (this.arrRectPoints[3].y + this.arrRectPoints[0].y) / 2 + lis
      let pointY3 = (this.heightInit + this.arrRectPoints[0].y) / 2 + lis
      let leftTextInfo = [
        { text: this.arrRectPoints[3].y, x: pointX1, y: pointY1 },
        { text: this.arrRectPoints[0].y - this.arrRectPoints[3].y, x: pointX1, y: pointY2 },
        { text: this.heightInit - this.arrRectPoints[0].y, x: pointX1, y: pointY3 }
      ]
      // console.log('this.arrRectPoints[3].y', this.arrRectPoints[3].y, 'this.arrRectPoints[0].y', this.arrRectPoints[0].y, JSON.stringify(this.arrRectPoints))
      leftTextInfo.forEach(item => {
        leftText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
        leftHelpText = this.$draw.toText(item.x, item.y, leftText, 'left')
        this.arrHelpText.push(leftHelpText)
      })

      // 下边的辅助文字
      let bottomText, bottomHelpText
      let bottomTextInfo = []
      let downNeDis = 0
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)) {
        downNeDis = this.helpNeDis
        bottomText = this.arrRectPoints[2].x - this.arrRectPoints[3].x
        pointX1 = (this.arrRectPoints[2].x + this.arrRectPoints[3].x) / 2
        pointY1 = this.heightInit + this.helpTextDis + bs
        bottomTextInfo.push({ text: bottomText, x: pointX1, y: pointY1 })
      }
      pointX1 = this.graph.pjX / 2
      pointX2 = (this.widthInit + this.graph.pjX) / 2
      pointY1 = this.heightInit + this.helpTextDis + bs + downNeDis
      bottomTextInfo.push({ text: this.graph.pjX, x: pointX1, y: pointY1 })
      bottomTextInfo.push({ text: this.widthInit - this.graph.pjX, x: pointX2, y: pointY1 })
      bottomTextInfo.forEach(item => {
        bottomText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
        bottomHelpText = this.$draw.toText(item.x, item.y, bottomText, 'bottom')
        this.arrHelpText.push(bottomHelpText)
      })
    },

    toCenter () {
      this.SET_HLENSSHIFT(0)
      this.PJX(this.houseInfo.roomW / 2)
    },
    testDigitalNegative (e, key, callBack) {
      e = e.replace(/[^(\-|+)0-9]/ig, '')
      this[key] = Number(e) || 0
      callBack && this[callBack](this[key] * 1)
    },

    setVlensShift (value) {
      if (isNaN(value)) {
        return
      }
      value = Number(value)
      var screenI
      if (this.$commonViewJs.isLShaped01()) {
        if (this.throwDistanceChecked && this.screenSizeChecked) {
          this.PJY(this.flToB + this.initScreenSize.h / 2 + this.initScreenSize.h * value / 100)
        } else if (this.throwDistanceChecked && !this.screenSizeChecked) {
          screenI = this.$commonViewJs.getInitScreenXyFromDist(this.$commonViewJs.getDistanceFromZorY())
          this.PJY(this.flToB + screenI.calY / 2 + screenI.calY * value / 100)
        }
      } else {
        if (this.throwDistanceChecked && this.screenSizeChecked) {
          this.PJZ(this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * value / 100))
        } else if (this.throwDistanceChecked && !this.screenSizeChecked) {
          screenI = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
          this.PJZ(this.houseInfo.roomH - (this.flToB + screenI.calY / 2 - screenI.calY * value / 100))
        }
      }
      this.$store.commit('SET_VLENSSHIFT', value)
    },

    checkRange (key, max, min) {
      if (this[key] === '') {
        this.$toast('必填')
        event.target.focus()
      }
      this[key] = this[key] > max ? max : this[key]
      this[key] = this[key] < min ? min : this[key]
      this.setVlensShift(this[key])
    },
    setHlensShift (value) {
      if (isNaN(value)) {
        return
      }
      value = Number(value)
      if (this.throwDistanceChecked && this.screenSizeChecked) {
        this.PJX(this.flToL + this.initScreenSize.w / 2 - this.initScreenSize.w * value / 100)
      } else if (this.throwDistanceChecked && !this.screenSizeChecked) {
        var screenI = this.$commonViewJs.getInitScreenXyFromDist(this.$commonViewJs.getDistanceFromZorY())
        this.PJX(this.flToL + screenI.calX / 2 - screenI.calX * value / 100)
      }
      this.$store.commit('SET_HLENSSHIFT', value)
    },

    checkRangeH (key, max, min) {
      if (this[key] === '') {
        this.$toast('必填')
        event.target.focus()
      }
      this[key] = this[key] > max ? max : this[key]
      this[key] = this[key] < min ? min : this[key]
      this.setHlensShift(this[key])
    },

    removeCenter (value) {
      this.position.x = value.x
      this.position.y = value.y + this.$refs.frontView.$el.offsetTop
    }
  },
  watch: {
    vLensShiftData: {
      handler (newValue, oldValue) {
        if (newValue === undefined) return
        this.vLensShiftDataInput = this.vLensShiftMax === this.vLensShiftMin ? 0 : Number(newValue.toFixed(0))
      },
      immediate: true
    },
    hLensShiftData: {
      handler (newValue, oldValue) {
        if (newValue === undefined) return
        this.hLensShiftDataInput = this.hLensShiftMax === this.hLensShiftMin ? 0 : Number(newValue.toFixed(0))
      },
      immediate: true
    },
    isLShaped01 (newValue, oldValue) {
      this.heightInit = newValue ? this.houseInfo.roomD : this.houseInfo.roomH
      this.$nextTick(function () {
        this.child.onHouseInfoChanged()
      })
    }
  }
}
</script>

<style scoped>
.front-view {
  position: relative;
  height: 100%;
  width: 100%;
  border-bottom: none;
  overflow: hidden;
}
.inline {
  width: 150px;
  height: 25px;
  border: 1px solid #cccccc;
  background: #fff;
  margin-left: 5px;
  margin-top: -27.5px;
  border-radius: 2.5px;
  display: inline-block;
}
.slider-h-line {
  background: #fff;
  border-bottom-left-radius: 2.5px;
  border-top-left-radius: 2.5px;
  display: inline-block;
  width: calc(100% - 31px);
  min-width: 71px;
  border-radius: 2.5px 0 0 2.5px;
  float: left;
  margin-left: 0.5px;
  padding: 0 8px;
}
.front_input_H {
  margin-top: 4px !important;
}
.slider-h-line::before{
  display: table
}

.horizontal {
  font-size: 0.21333rem;
  display: inline-block;
  vertical-align: text-bottom;
  float: none;
  margin: 0 5px;
  line-height: 30px;
}
.none {
  visibility: hidden;
  margin-bottom: 3.5px;
}
.graph-view_slider-input{
  margin-top:3px
}
.front-img {
  background: url('../../assets/parts/icon/icon_front.png') no-repeat center;
  width: 15px;
  height: 15px;
  float: left;
}

.el-slider__runway {
    background-color: #999999;
    margin: 10px 5px;
    height: 1px;
    border-radius: 0px;
    width: 90%;
}

.slider-input-panel {
  float: left;
  position: relative;
  width: 30px;
  text-align: center;
  height: 100%;
  background: #f0f0f0;
  border-radius: 0 2.5px 2.5px 0;
  border-left:1px solid #cccccc;
}

</style>
